import { QuillDeltaToHtmlConverter } from "quill-delta-to-html";
import { resolveMention } from "modules/quill/mentions/mention-registry";
import { CALLOUT_KEY, HASH_KEY, MENTION_TYPE } from "modules/utils/Constants";
import {
  DistributionGroupFragment,
  TagFragment,
  UserFragment,
} from "gql/graphql";
import colors from "app/colors";

export const quillDeltaToHtml = (delta: string | null | undefined): string => {
  if (!delta) return "";
  try {
    const parsed = JSON.parse(delta);
    const ops = parsed.ops ?? (Array.isArray(parsed) ? parsed : []);
    const converter = new QuillDeltaToHtmlConverter(ops);
    converter.renderCustomWith((customOp) => {
      if (customOp.insert.type === "mention") {
        const { id, type } = customOp.insert.value;
        const entity = resolveMention(id, type);

        if (!entity) return `<span>@unknown</span>`;

        switch (type) {
          case MENTION_TYPE.USER: {
            const user = entity as UserFragment;
            const isExternal = user.roleType === "EMAIL";
            const color = isExternal ? colors.blueGreen : colors.blue;
            const display = isExternal
              ? (user.email ?? "")
              : `${CALLOUT_KEY}${user.callout ?? user.firstName}`;
            return `<span style="color:${color};font-weight:600;">${display}</span>`;
          }
          case MENTION_TYPE.DISTRIBUTION_GROUP: {
            const group = entity as DistributionGroupFragment;
            return `<span style="color:#2563eb;font-weight:600;">${CALLOUT_KEY}${group.name}</span>`;
          }
          case MENTION_TYPE.TAG: {
            const tag = entity as TagFragment;
            return `<span style="color:#2563eb;font-weight:600;">${HASH_KEY}${tag.name}</span>`;
          }
          default:
            return "";
        }
      }
      return "";
    });
    return converter.convert();
  } catch {
    return delta ?? "";
  }
};
